const get = require('lodash/object/get');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');
// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { recordProcess } = require("utilities/tagging");
const { formatText } = require('core/i18n').i18n;

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @utils
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_FIRST_STEP,
    EURO_TEXT,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_CODE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_CODE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_CODE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_CODE,
    CHARGE_ACCOUNT_PREFIX,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_PLAN_LEGAL_DOCUMENT_DDFP,
    CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS,
 } = require('constants/index');

 const { BROKER_EXTRAORDINARY_PENSION_PLAN } = require('utilities/tagging');

const reset = () => ({ type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_RESET });

const sendRequest = () => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_REQUEST
});

const setPeriodicity = available => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SET_PERIODICITY,
    payload: {
        available
    }
});

const resetFlagErrorOfRevAnual = () => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_RESET_FLAG_ERROR_REVANUAL,
});

const setRevAnualPercentage = (available) => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SET_REVANUAL_PERCENTAGE_AVAILABLE,
    payload: {
        available
    }
});

const setAvailablePercentageInput = (available) => (dispatch) => {
    dispatch(resetFlagErrorOfRevAnual());
    dispatch(setRevAnualPercentage(available));
};

const setPercentagePeriodiclyAmount = value => ({
    type: actionTypes.BROKER_PENSION_PLAN_PERCENTAGE_PERIODICLY_VALUE,
    payload: {
        value: value !== 0 ? value : ''
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateUIStep = step => (dispatch, getState) => {
    const immBrokerPensionPlans = getState().brokerPensionPlans;
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;
    const step1 = immBrokerPensionPlanContribution.getIn(['steps', FIRST_STEP]);

    let accountBalance;
    let periodicityMinimum;
    if (step === 1) {
        const immPensionPlanContribution = getState().brokerPensionPlanContribution;
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');
        let associatedAccountNumber;
        if (walletPlan) {
            const associatedAccount = walletPlan.get('cuentaAsociada');
            const office = associatedAccount.get('oficina');
            associatedAccountNumber = office.get('entidad')+office.get('oficina')+associatedAccount.get('digitodecontrol')+associatedAccount.get('numerodecuenta');
        }
        const immAccounts = getState().accounts;
        const selectedAccount = immAccounts.get('byId').find(account =>
            account.getIn(['ibanComplex', 'codbban']) === associatedAccountNumber
        );

        accountBalance = {
            amount: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'amount']) : '',
            currency: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'currency']) : ''
        };

        if (!step1.get('setPeriodicity')) {
            periodicityMinimum = immPensionPlanContribution.getIn(['pensionPlan', 'CustomMinimumPurchaseAmount']);

        } else {
            periodicityMinimum = immPensionPlanContribution.getIn(['steps', FIRST_STEP]).get('periodicityMinimum');
        }
    }

    const contributionMinimumAmount = periodicityMinimum;
    const contributionMinimumAmountCurrency = immBrokerPensionPlans.getIn(['pensionPlan', 'contributionMinimumAmountCurrency']);

    dispatch({
        type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_VALIDATE_STEP,
        payload: { step, contributionMinimumAmount, contributionMinimumAmountCurrency , accountBalance }
    });
};

const saveDocumentationSuccess = () => ({
    type: actionTypes.BROKER_PENSION_PLAN_SEND_DOCUMENTATION_SUCCESS
});
const saveDocumentationFailure = () => ({
    type: actionTypes.BROKER_PENSION_PLAN_SEND_DOCUMENTATION_FAILURE
});

const saveDocumentation = (response) => (dispatch, getState) => {
    let amount, currency;
    const immPensionPlanContribution = getState().brokerPensionPlanContribution;
    const emittedDateTime = momentTz(
        parseInt(get(response, "timestamp", ""), 10)
    ).tz("Europe/Madrid");
    const immPensionPlan = immPensionPlanContribution.get("pensionPlan");
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const dgsCode = immPensionPlan.get("DGSCode");
    const isinDescribe = immPensionPlan.get("Name");
    const immPensionPlanStepOne = immPensionPlanContribution.getIn([
        "steps",
        FIRST_STEP,
    ]);
    const planData = immPensionPlanContribution.get("extraordinaryData");
    const validationData = immPensionPlanContribution.get("validationData");

    if (immPensionPlanStepOne.get("setPeriodicity")) {
        amount = immPensionPlanStepOne.get("periodiclyAmount");
        currency = validationData
            ? validationData.get("codmonProd")
            : EURO_TEXT;
    } else {
        amount = immPensionPlanStepOne.get("originalAmount");
        currency = planData ? planData.get("divisaDelMovimiento") : EURO_TEXT;
    }

    const walletPlan = immPensionPlanContribution.get("pensionPlanFromWallet");
    const contractNumber = walletPlan.getIn(["contrato", "numerodecontrato"]);
    const productNumber = walletPlan.getIn(["contrato", "producto"]);
    const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
    const immDocuments = immBrokerLegalDocumentation.getIn([
        "boxes",
        dgsCode,
        "documents",
    ]);
    const immProfile = getState().profile;

    const validityDate = immPensionPlanStepOne
        .get("validityDate")
        .format("YYYY-MM-DD");
    let boletinAdhesion, marketingReport, contract, economicReport;
    if (__CONTACT_CENTER__) {
        const publicSiteUrl = apiURLBuilder.getPublicSiteUrl().split("/en")[0];
        boletinAdhesion = `${publicSiteUrl}/assets/static/pdf/planes/boletines/${dgsCode}.pdf`
        marketingReport = apiURLBuilder.getURL(
            'morningstarPlanLegalDocumentUrl',
            {
                dgscode: dgsCode,
                documentType: BROKER_PLAN_LEGAL_DOCUMENT_DDFP,
                originCountry: getState().profile.get('originCountry')
            }
        )
        contract = CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS
        economicReport = apiURLBuilder.getURL(
            'morningstarPlanLegalDocumentUrl',
            {
                dgscode: dgsCode,
                documentType: 'Especificaciones',
                originCountry: getState().profile.get('originCountry')
            }
        )
    } else {
        boletinAdhesion = immDocuments.getIn(["ADHESION_BULLETIN", "url"]);
        marketingReport = immDocuments.getIn(["DDFP", "url"]);
        contract = immDocuments.getIn(["SERVICES_CONTRACT", "url"]);
        economicReport = immDocuments.getIn(["SPECIFICATIONS", "url"]);
    }
    const communicationServiceInput = {
        boletinAdhesion: boletinAdhesion,
        productKID: "",
        personType: immProfile.getIn(["codigoPersona", "type"]),
        clientId: immProfile.getIn(["codigoPersona", "f"]),
        contract,
        economicReport: economicReport,
        marketingReport: marketingReport,
        sendOrder: "no",
        clientAlias: immProfile.get("nombreCliente"),
        isin: dgsCode,
        isinDescribe: isinDescribe,
        idOrder: get(response, "numeroOrden", ""),
        channel: CONNECTION_CHANNEL_INTERNET,
        orderType: "documentos",
        productType: "",
        holders: "",
        ccv: chargeAccount,
        idContract: chargeAccount,
        ccc: get(
            response,
            ["datosCuentaAsociada", "codIban", "codbban"],
            ""
        ).trim(),
        market: "",
        sharesNumber: 0,
        sharesAmount: amount,
        termValidity: validityDate,
        conditionPrize: "",
        currency: currency,
        dateTime: emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        saveDocumentation: true,
    };

    const data = {
        query: communicationServiceInput,
    };
    return APIPost(dispatch, apiURLBuilder.getURL("communication"), data)
        .then(() => dispatch(saveDocumentationSuccess()))
        .catch(() => dispatch(saveDocumentationFailure()));
};


const extrordinaryContributionSuccess = response => ({
    type: actionTypes.BROKER_PENSION_PLAN_EXTRAORDINARY_CONTRIBUTION_SUCCESS,
    payload: {
        response
    }
});

const extrordinaryContributionError = error => ({
    type: actionTypes.BROKER_PENSION_PLAN_EXTRAORDINARY_CONTRIBUTION_ERROR,
    payload: {
        error
    }
});

const periodicContributionSuccess = response => ({
    type: actionTypes.BROKER_PENSION_PLAN_PERIODIC_CONTRIBUTION_SUCCESS,
    payload: {
        response
    }
});

const periodicContributionError = error => ({
    type: actionTypes.BROKER_PENSION_PLAN_PERIODIC_CONTRIBUTION_ERROR,
    payload: {
        error
    }
});

const validationSuccess = response => ({
    type: actionTypes.BROKER_PENSION_PLAN_VALIDATION_SUCCESS,
    payload: {
        response
    }
});

const validationSuccessEdit = response => ({
    type: actionTypes.BROKER_PENSION_PLAN_VALIDATION_EDIT_SUCCESS,
    payload: {
        response
    }
});

const validationError = error => ({
    type: actionTypes.BROKER_PENSION_PLAN_VALIDATION_ERROR,
    payload: {
        error
    }
});

const contributonError = error => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_ERROR,
    payload: {
        error
    }
});

const constributionSuccess = () => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SUCCESS
});

const confirmContribution = function(dispatch, getState, dataToken, history) {
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;
    const plan = immBrokerPensionPlanContribution.get('extraordinaryData');
    const walletPlan = immBrokerPensionPlanContribution.get('pensionPlanFromWallet');
    const validationData = immBrokerPensionPlanContribution.get('validationData');
    const periodicData = immBrokerPensionPlanContribution.get('periodicData');
    const step1 = immBrokerPensionPlanContribution.getIn(['steps', FIRST_STEP]);
    const monthlyPeriodicValue = step1.get('periodiclyMonthlyValue');
    const isEditMode = immBrokerPensionPlanContribution.get('isEditMode');
    const contributionDataEdit = immBrokerPensionPlanContribution.get('contributionDataEdit');
    const monthlyPeriodic = step1.getIn([
        'periodiclyMonthlyOptions',
        monthlyPeriodicValue,
        'frecuenciaCuotaCada'
    ]);
    const monthlyPeriodicTime = step1.getIn([
        'periodiclyMonthlyOptions',
        monthlyPeriodicValue,
        'frecuenciaCuotaCadaUnidadDeTiempo'
    ]);
    const monthlyPeriodicTotal = step1.getIn([
        'periodiclyMonthlyOptions',
        monthlyPeriodicValue,
        'value'
    ]);
    const revAnualValue = step1.get('revAnual');
    const revAnual = revAnualValue.importeOPorcentajeRevalorización;
    const revAnualType = revAnualValue.tipoRetVal;
    let query, url;

    if (!step1.get('setPeriodicity')) {
        url = 'brokerPensionPlanExtraordinaryContributionConfirm';
        query = {
            codOpera: plan.get('codOpera'),
            codSubtipoProd: plan.get('codSubtipoProd'),
            codigoIdioma: plan.get('codigoIdioma'),
            ctaAsociada: {
                digitodecontrol: walletPlan.getIn(['cuentaAsociada', 'digitodecontrol']),
                numerodecuenta: walletPlan.getIn(['cuentaAsociada', 'numerodecuenta'])
            },
            dataToken: dataToken,
            datosConexion: {
                contratoSeleccionado: {
                    numerodecontrato: walletPlan.getIn(['contrato', 'numerodecontrato']),
                    producto: walletPlan.getIn(['contrato', 'producto'])
                }
            },
            descriPlan: plan.get('descriPlan'),
            fecUltimValLiq: plan.get('fecUltimValLiq'),
            fecValorBanc: plan.get('fecValorBanc'),
            fecValorLiquid: plan.get('fecValorLiquid'),
            impSaldo: plan.get('impSaldo'),
            importeDelMovimiento: {
                divisa: walletPlan.getIn(['saldo1', 'divisa']),
                importe: step1.get('originalAmount')
            },
            importeOParticipaciones: 0,
            importeParticipaciones: step1.get('originalAmount'),
            indAccion3: plan.get('indAccion3'),
            nomTItular: plan.get('nomTItular'),
            numEmpleado: '',
            swIndOpConf: plan.get('swIndOpConf'),
            tipoEmpresa: plan.get('tipoEmpresa'),
            valorLiq: {
                divisa: plan.get('valorLiqDivisa'),
                valorliquidativo: plan.get('valorLiqMonto')
            }
        };
    } else {
        if (isEditMode) {
            url = 'brokerPensionPlanEditContributionConfirm';
            query = {
                codIdio: validationData.get('codIdioma'),
                codMonProducto: (validationData.get('codmonProd') ? validationData.get('codmonProd'): EURO_TEXT),
                contrato: walletPlan.getIn(['contrato', 'numerodecontrato']),
                cuentaAsociada: {
                    codbban: validationData.get('codbban'),
                    digitodecontrol: validationData.get('digitodecontrol'),
                    pais: validationData.get('pais')
                },
                dataToken: dataToken,
                fecSiguienReval: validationData.get('fecProxReval'),
                fechaAlta: contributionDataEdit.get('fechaAlta'),
                fechaIniPlanAport: validationData.get('fechaIni'),
                fechaIniPriReval: validationData.get('fecRevalorizacion'),
                frecuenciaRevalUnidad: validationData.get('frecRevalorizaUnidadTiempo'),
                frecuenciaRevalorizaCada:  validationData.get('frecuenciaRevalorizaCada'),
                importeAportPlan: {
                    divisa: validationData.get('codmonProd')
                    ? validationData.get('codmonProd')
                    : EURO_TEXT,
                    importe: step1.get('periodiclyAmount')
                },
                importeOPorcentajeReval: revAnual,
                indCuentaDistintoCentro: validationData.get('indCuentaDistintoCentro'),
                indCuentaMismoDelPlan: validationData.get('indCuentaMismaDelPlan'),
                indCuentaParticipeNoTitu: validationData.get('indParticipenoTitularCta'),
                indImporteParaCuota: validationData.get('indImporteParaCuota'),
                indPorMinReval: contributionDataEdit.get('indPorMinReval'),
                indRevalOblig: contributionDataEdit.get('indRevalOblig'),
                indTipoMinus: validationData.get('indTipoMinus'),
                numeroDeParticipe: contributionDataEdit.get('numeroParticipe'),
                periodicidad: monthlyPeriodicTotal,
                producto: walletPlan.getIn(['contrato', 'producto']),
                revalorizacion: revAnualType,
                situacionPlanAporta: contributionDataEdit.getIn(['planAportacion','status']),
                subtipoPlanPensiones: contributionDataEdit.get('subtipoPlanPensiones'),
                timestampAlta: contributionDataEdit.getIn(['planAportacion','timestampAlta']),
                tipoApor: contributionDataEdit.getIn(['planAportacion','tipo']),
                tipoPlan: validationData.get('tipoPlan')
            }
        } else {
            url = 'brokerPensionPlanContributionConfirm';
            query = {
                cccDelGrupoAportaciones: {
                    codbban: validationData.get('codbban'),
                    digitodecontrol: validationData.get('digitodecontrol'),
                    pais: validationData.get('pais')
                },
                codIdioma: validationData.get('codIdioma'),
                codPersonaTitularContrPrin: {
                    codigodepersona: periodicData.get('codigodepersona'),
                    tipodepersona: periodicData.get('tipodepersona')
                },
                codmonProd: validationData.get('codmonProd')
                    ? validationData.get('codmonProd')
                    : EURO_TEXT,
                dataToken: dataToken,
                contrato: walletPlan.getIn(['contrato', 'numerodecontrato']),
                producto: walletPlan.getIn(['contrato', 'producto']),
                fecRevalorizacion: validationData.get('fecRevalorizacion'),
                fechaIni: step1.get('validityDate').format("YYYY-MM-DD"),
                fechaMod: validationData.get('fechaMod'),
                frecRevalorizaUnidadTiempo: validationData.get('frecRevalorizaUnidadTiempo'),
                frecuenciaCuotaCada: monthlyPeriodic,
                frecuenciaCuotaUnidadDeTiempo: monthlyPeriodicTime,
                frecuenciaRevalorizaCada: validationData.get('frecuenciaRevalorizaCada'),
                idsubtipo: periodicData.get('idsubtipo'),
                importeOPorcentajeRevalorizacion: revAnual,
                importesel: {
                    divisa: validationData.get('codmonProd')
                        ? validationData.get('codmonProd')
                        : EURO_TEXT,
                    importe: step1.get('periodiclyAmount')
                },
                indCuentaDistintoCentro: validationData.get('indCuentaDistintoCentro'),
                indCuentaMismaDelPlan: validationData.get('indCuentaDistintoCentro'),
                indDomiciBancaria: validationData.get('indDomiciBancaria'),
                indParticipenoTitularCta: validationData.get('indParticipenoTitularCta'),
                numeroDeParticipe: validationData.get('numeroDeParticipe'),
                switcho: periodicData.get('switcho'),
                swopcc: periodicData.get('swopcc'),
                tipoPlan: periodicData.get('tipoPlan'),
                revalorizacion: revAnualType,
                periodicidad: monthlyPeriodicTotal
            };
        }
    }

    const requestData = {
        query: query
    };

    dispatch(sendRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(url), requestData)
    .then(response => {
        dispatch(saveDocumentation(response));
        dispatch(constributionSuccess());
        }).catch(response => {
            const error = !!response.body ? response.body.error : ''
            dispatch(errorActions.show('brokerAPIErrors-' + error, false, history));
            dispatch(contributonError(response));
            if (url === 'brokerPensionPlanExtraordinaryContributionConfirm') {
                taggingEventHandled(BROKER_EXTRAORDINARY_PENSION_PLAN, 'otpSuccess')
                recordProcess(
                    'proc-broker-aporte-planes-pension',
                    'error',
                    {
                        tipoError: formatText('pensionPlanContribution-taggingErrorConfirm'),
                    },
                    true
                );
            } else {
                recordProcess(
                    'proc-broker-aporte-planes-pension-periodic',
                    'error',
                    {
                        tipoError: formatText('pensionPlanPeriodicalContribution-taggingErrorConfirm'),
                    },
                    true
                );
            }
        });
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        confirmContribution(dispatch, getState, dataToken, history);
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validatePeriodicContributionEdit = (history) => (dispatch, getState) => {
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;
    const contributionDataEdit = immBrokerPensionPlanContribution.get('contributionDataEdit');
    //const revAnual = immBrokerPensionPlanContribution.getIn(['steps', FIRST_STEP, 'revAnual']);

    const requestData = {
        query: {
            codigoSubProducto: contributionDataEdit.get('subtipoPlanPensiones'),
            datosConexion: {
                contratoSeleccionado: {
                    numerodecontrato: contributionDataEdit.getIn(['contrato','numerodecontrato']),
                    producto: contributionDataEdit.getIn(['contrato','producto'])
              }
            },
            divisa: contributionDataEdit.get('divisa'),
            fechaAlta: contributionDataEdit.get('fechaAlta'),
            revalorizAnual: contributionDataEdit.getIn(['planAportacion','revalorizacionAnual']),
            timestampAlta: contributionDataEdit.getIn(['planAportacion','timestampAlta']),
            tipoApor: contributionDataEdit.getIn(['planAportacion','tipo']),
            tipoPlan: contributionDataEdit.get('tipoPlan')
        }
    };

    dispatch(sendRequest());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('brokerPensionPlanContributionValidationEdit'),
        requestData
    )
        .then(response => dispatch(validationSuccessEdit(response)))
        .catch(response => {
            dispatch(validationError(response));
            dispatch(errorActions.show('brokerAPIErrors-' + response.body.error, false, history));
        });
};

const getExtraordinaryContributions = (history) => (dispatch, getState) => {
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;

    const requestData = {
        query: {
            producto: immBrokerPensionPlanContribution.getIn([
                'pensionPlanFromWallet',
                'contrato',
                'producto'
            ]),
            numeroContrato: immBrokerPensionPlanContribution.getIn([
                'pensionPlanFromWallet',
                'contrato',
                'numerodecontrato'
            ])
        }
    };

    dispatch(sendRequest());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerPensionPlanExtraordinaryContribution'),
        requestData
    )
        .then(response => dispatch(extrordinaryContributionSuccess(response)))
        .catch(response => {
            dispatch(extrordinaryContributionError(response));
            dispatch(errorActions.show('brokerAPIErrors-' + response.body.error, true, history));
        });
};

const validatePeriodicContribution = (data, history) => (dispatch, getState) => {
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;
    const monPlan = data.listaPlanAportaciones && data.listaPlanAportaciones.planAportacion[0]
        ? data.listaPlanAportaciones.planAportacion[0].divisaImporteAportPlan
        : EURO_TEXT;

    const requestData = {
        query: {
            codPersonaTitularContrPrin: {
                codigodepersona: data.codPersonaTitContrPrin.codigodepersona,
                tipodepersona: data.codPersonaTitContrPrin.tipodepersona
            },
            codmonedaplan: monPlan,
            datosConexion: {
                contratoSeleccionado: {
                    numerodecontrato: immBrokerPensionPlanContribution.getIn([
                        'pensionPlanFromWallet',
                        'contrato',
                        'numerodecontrato'
                    ]),
                    producto: immBrokerPensionPlanContribution.getIn([
                        'pensionPlanFromWallet',
                        'contrato',
                        'producto'
                    ])
                }
            }
        }
    };

    dispatch(sendRequest());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('brokerPensionPlanContributionValidation'),
        requestData
    )
        .then(response => dispatch(validationSuccess(response)))
        .catch(response => {
            dispatch(validationError(response));
            dispatch(errorActions.show('brokerAPIErrors-' + response.body.error, true, history));
        });
};

const getPeriodicContributions = (history) => (dispatch, getState) => {
    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;

    const requestData = {
        query: {
            producto: immBrokerPensionPlanContribution.getIn([
                'pensionPlanFromWallet',
                'contrato',
                'producto'
            ]),
            numeroContrato: immBrokerPensionPlanContribution.getIn([
                'pensionPlanFromWallet',
                'contrato',
                'numerodecontrato'
            ])
        }
    };

    dispatch(sendRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerPensionPlanContribution'), requestData)
        .then(response => {
            dispatch(periodicContributionSuccess(response));
            dispatch(validatePeriodicContribution(response, history));
        })
        .catch(response => {
            dispatch(periodicContributionError(response));
            dispatch(errorActions.show('brokerAPIErrors-' + response.body.error, true, history));
        });
};

const validateStep = (step, history) => (dispatch, getState) => {
    dispatch(validateUIStep(step));

    const immBrokerPensionPlanContribution = getState().brokerPensionPlanContribution;
    const isEditMode = immBrokerPensionPlanContribution.get('isEditMode');

    switch (step) {
        case WIZARD_FIRST_STEP:
            const firstStepValid = immBrokerPensionPlanContribution.getIn([
                'steps',
                FIRST_STEP,
                'valid'
            ]);
            const isPeriodicitySet = immBrokerPensionPlanContribution.getIn([
                'steps',
                FIRST_STEP,
                'setPeriodicity'
            ]);

            if (firstStepValid) {
                if (!isPeriodicitySet) {
                    dispatch(getExtraordinaryContributions(history));
                } else {
                    if (isEditMode) {
                        dispatch(validatePeriodicContributionEdit(history))
                    } else {
                        dispatch(getPeriodicContributions(history));
                    }
                }
            }

            break;
        case WIZARD_SECOND_STEP:
            const secondStepValid = immBrokerPensionPlanContribution.getIn([
                'steps',
                SECOND_STEP,
                'valid'
            ]);

            if (secondStepValid) {
                dispatch(finish(history));
            }

            break;
    }
};

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const setPlanContract = walletPlan => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SET_CONTRACT,
    payload: {
        walletPlan
    }
});

const getPlanFullContractNumber = (walletPlan, immPlans) => {
    const immPlan = immPlans.find(immPlan =>
        immPlan.get('numerodecontrato') === walletPlan.getIn(['contrato', 'numerodecontrato']) &&
        immPlan.get('producto') === walletPlan.getIn(['contrato', 'producto']));
    return immPlan ? immPlan.get('contractForTooltip') : '';
}

const setContract = (walletPlan, history) => (dispatch, getState) => {
    const immPlans = getState().brokerMyInvestments.getIn(['products', 'plans', 'stocks']);
    if (!!walletPlan) {
        const fullContractNumber = getPlanFullContractNumber(walletPlan, immPlans);
        const walletPlanWithFullContract = walletPlan.setIn(['contrato', 'fullContractNumber'], fullContractNumber);
        dispatch(setPlanContract(walletPlanWithFullContract));
    } else {
        dispatch(errorActions.show('', true, history));
    }
};

const setOriginalAmountValue = amount => ({
    type: actionTypes.BROKER_PENSION_PLAN_CONTRIBUTION_SET_ORIGINAL_AMOUNT,
    payload: {
        amount
    }
});

const setOriginalAmount = amount => dispatch => {
    dispatch(setOriginalAmountValue(amount));
};

const setPeriodiclyMonthlyValue = (value, periodicityMinimum) => ({
    type: actionTypes.BROKER_PENSION_PLAN_PERIODICLY_MONTH_VALUE,
    payload: {
        value: value.value,
        label: value.label,
        periodicityMinimum: periodicityMinimum
    }
});

const setPeriodiclyMonthly = value => (dispatch, getState) => {
    const immBrokerPensionPlans= getState().brokerPensionPlans;
    const periodicity = value.value;
    let periodicityMinimum;
    switch (periodicity) {
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_CODE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'monthlyMinimum']);
        }
        break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_TRIANUAL_CODE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'triannualMinimum']);
        }
        break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_BIANUAL_CODE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'biannualMinimum']);
        }
        break;
        case BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_ANUAL_CODE: {
            periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'annualMinimum']);
        }
        break;
        default: periodicityMinimum = immBrokerPensionPlans.getIn(['pensionPlan', 'monthlyMinimum']);
    }
    dispatch(setPeriodiclyMonthlyValue(value, periodicityMinimum));
};

const setRevAnualValue = value => ({
    type: actionTypes.BROKER_PENSION_PLAN_REV_ANUAL_VALUE,
    payload: {
        value
    }
});

const setRevAnual = value => dispatch => {
    dispatch(setRevAnualValue(value));
};

const setPeriodiclyAmountValue = value => ({
    type: actionTypes.BROKER_PENSION_PLAN_PERIODICLY_AMOUNT_VALUE,
    payload: {
        value
    }
});

const setPeriodiclyAmount = value => dispatch => {
    dispatch(setPeriodiclyAmountValue(value));
};

const setValidityDateValue = date => ({
    type: actionTypes.BROKER_PENSION_PLAN_VALIDITY_DATE_VALUE,
    payload: {
        date
    }
});

const setValidityDate = date => dispatch => {
    dispatch(setValidityDateValue(date));
};

const toggleDisclaimer = () => dispatch =>
    dispatch({
        type: actionTypes.BROKER_PENSION_PLAN_TOGGLE_DISCLAIMER,
        payload: {}
    });

const setContractNumber = (contractNumber) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_PENSION_PLAN_SET_CONTRACT_NUMBER,
        payload: { contractNumber }
    });
};

const getPeriodicalContributionSuccess = (contributionData, detailsData) => ({
    type: actionTypes.BROKER_PLAN_PERIODICAL_CONTRIBUTION_SUCCESS_EDIT,
    payload: {
        contributionData,
        detailsData
    }
});

const getPeriodicalContributionError = () => ({
    type: actionTypes.BROKER_PLAN_PERIODICAL_CONTRIBUTION_ERROR_EDIT,
});

const requestGetPeriodicalContribution = () => ({
    type: actionTypes.BROKER_PLAN_PERIODICAL_CONTRIBUTION_REQUEST_EDIT,
});

const getPeriodicalContributionDetails = (responseList, contributionDate) => (dispatch) => {

    const immContributions = Immutable.fromJS(responseList);
    const immContributionsList = immContributions.get('aportacionesPeriodicas');

    const contributionToEdit = immContributionsList.find(
        immContribution => immContribution.getIn(['planAportacion','timestampAlta']) === contributionDate
    );

    const requestData = {
        query: {
            producto: contributionToEdit.getIn(['contrato','producto']),
            numeroContrato: contributionToEdit.getIn(['contrato','numerodecontrato']),
            timeStamp: contributionToEdit.getIn(['planAportacion','timestampAlta']),
            tipoApor: contributionToEdit.getIn(['planAportacion','tipo']),
            revalAnual: contributionToEdit.getIn(['planAportacion','revalorizacionAnual'])
        }
    };


    dispatch(requestGetPeriodicalContribution());
    return APIGet(dispatch, apiURLBuilder.getURL('planPeriodicalContributionDetails'), requestData)
    .then(response => {
        dispatch(getPeriodicalContributionSuccess(contributionToEdit, response));
    })
    .catch(response => {
        dispatch(getPeriodicalContributionError(response.error))
    });
};

const getPeriodicalContribution = (contributionDate) => (dispatch) => {

    dispatch(requestGetPeriodicalContribution());
    return APIGet(dispatch, apiURLBuilder.getURL('planPeriodicalContribution'))
    .then(response => {
            dispatch(getPeriodicalContributionDetails(response, contributionDate));
    })
    .catch(response => {
        dispatch(getPeriodicalContributionError(response.error))
    });
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_PENSION_PLAN_EXTRAORDINARY_CONTRIBUTION_DOCUMENTS_READ
});

module.exports = {
    reset,
    setVisibleStep,
    validateStep,
    setWillCancel,
    finish,
    setPeriodicity,
    setContract,
    setOriginalAmount,
    setRevAnual,
    setPeriodiclyMonthly,
    setPeriodiclyAmount,
    setValidityDate,
    toggleDisclaimer,
    setContractNumber,
    setAvailablePercentageInput,
    setPercentagePeriodiclyAmount,
    getPeriodicalContribution,
    setDocumentsRead,
    saveDocumentation
};